export default {
    A1: {
        t: 's',
        v: '',
    },
    A2: {
        t: 's',
        v: '',
    },
    L2: {
        t: 's',
        v: '',
    },
    A3: {
        t: 's',
        v: '會計項目',
    },
    B3: {
        t: 's',
        v: '1',
    },
    C3: {
        t: 's',
        v: '2',
    },
    D3: {
        t: 's',
        v: '3',
    },
    E3: {
        t: 's',
        v: '4',
    },
    F3: {
        t: 's',
        v: '5',
    },
    G3: {
        t: 's',
        v: '6',
    },
    H3: {
        t: 's',
        v: '7',
    },
    I3: {
        t: 's',
        v: '8',
    },
    J3: {
        t: 's',
        v: '9',
    },
    K3: {
        t: 's',
        v: '10',
    },
    L3: {
        t: 's',
        v: '11',
    },
    M3: {
        t: 's',
        v: '12',
    },
    N3: {
        t: 's',
        v: '總和',
    },
    '!ref': 'A1:N3',
    '!merges': [
        { s: { c: 0, r: 0 }, e: { c: 13, r: 0 } },
        { s: { c: 11, r: 1 }, e: { c: 13, r: 1 } },
        { s: { c: 0, r: 1 }, e: { c: 10, r: 1 } },
    ],
};
